import { render, staticRenderFns } from "./UsagesPage.vue?vue&type=template&id=58fc40bb&scoped=true&"
import script from "./UsagesPage.vue?vue&type=script&lang=js&"
export * from "./UsagesPage.vue?vue&type=script&lang=js&"
import style0 from "./UsagesPage.vue?vue&type=style&index=0&id=58fc40bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc40bb",
  null
  
)

export default component.exports